import { gql } from '@apollo/client'

export const REMOVE_FROM_JOB = gql`
  mutation removeFromJob($deleteWorkspaceJobPinInput: [DeleteWorkspaceJobPinInput!]!, $workspaceJobId: String!) {
    deleteWorkspaceJobPins(deleteWorkspaceJobPinInput: $deleteWorkspaceJobPinInput, workspaceJobId: $workspaceJobId) {
      message
      success
    }
  }
`
